import React from 'react';

interface ObstacleTileProps {
  type: 'rock' | 'lava' | 'stop' | 'end' | 'start' | 'teleporter' | 'enemy';
  size?: number;
  className?: string;
}

const ObstacleTile: React.FC<ObstacleTileProps> = ({ type, size = 60, className = '' }) => {
  const tileStyle: React.CSSProperties = {
    width: `${size}px`,
    height: `${size}px`,
    position: 'relative',
    borderRadius: '8px',
    overflow: 'hidden',
    display: 'inline-block',
  };

  const getObstacleContent = () => {
    switch (type) {
      case 'rock':
        return (
          <>
            <div className="rock-texture"></div>
            <div className="rock-highlight"></div>
            <div className="rock-shadow"></div>
          </>
        );
      case 'lava':
        return (
          <>
            <div className="lava-bubble lava-bubble-1"></div>
            <div className="lava-bubble lava-bubble-2"></div>
            <div className="lava-bubble lava-bubble-3"></div>
            <div className="lava-wave"></div>
          </>
        );
      case 'stop':
        return (
          <>
            <div className="ice-crystals">
              <div className="crystal crystal-1"></div>
              <div className="crystal crystal-2"></div>
              <div className="crystal crystal-3"></div>
            </div>
            <div className="ice-shimmer"></div>
            <div className="ice-sweep"></div>
          </>
        );
      case 'end':
        return (
          <>
            <div className="victory-rings">
              <div className="ring ring-1"></div>
              <div className="ring ring-2"></div>
              <div className="ring ring-3"></div>
            </div>
            <div className="star-sparkle sparkle-1"></div>
            <div className="star-sparkle sparkle-2"></div>
            <div className="star-sparkle sparkle-3"></div>
            <div className="star-sparkle sparkle-4"></div>
          </>
        );
      case 'start':
        return (
          <>
            <div className="start-pulse"></div>
            <div className="start-icon">S</div>
          </>
        );
      case 'teleporter':
        return (
          <>
            <div className="teleporter-spiral"></div>
            <div className="teleporter-glow"></div>
            <div className="teleporter-particles">
              <div className="particle particle-1"></div>
              <div className="particle particle-2"></div>
              <div className="particle particle-3"></div>
            </div>
          </>
        );
      case 'enemy':
        return (
          <>
            <div className="enemy-glow"></div>
            <div className="enemy-icon" style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: `${size * 0.5}px`,
              fontWeight: 'bold',
              color: '#ff6b6b',
              textShadow: '0 0 8px rgba(255,107,107,0.6)',
            }}>N</div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div 
      className={`game__cell game__cell--${type} obstacle-tile obstacle-tile--${type} ${className}`}
      style={tileStyle}
    >
      {getObstacleContent()}
    </div>
  );
};

export default ObstacleTile;